import { Component } from '@angular/core';
import { IntroThreeComponent } from './intro-three.component';

@Component({
  selector: 'eid-intro-three-desktop',
  templateUrl: './intro-three.desktop.component.html',
  styleUrls: ['./intro-three.desktop.component.scss']
})
export class IntroThreeDesktopComponent extends IntroThreeComponent {}
